import { render, staticRenderFns } from "./c_ueditor_box.vue?vue&type=template&id=296d4ca9&scoped=true"
import script from "./c_ueditor_box.vue?vue&type=script&lang=js"
export * from "./c_ueditor_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d4ca9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296d4ca9')) {
      api.createRecord('296d4ca9', component.options)
    } else {
      api.reload('296d4ca9', component.options)
    }
    module.hot.accept("./c_ueditor_box.vue?vue&type=template&id=296d4ca9&scoped=true", function () {
      api.rerender('296d4ca9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_ueditor_box.vue"
export default component.exports